import { HatElement } from '@/components/hat-element.js';

class CameraCapture extends HatElement {
  private devices: MediaDeviceInfo[] = [];
  private currentDeviceId: string | null = null;
  private stream: MediaStream | null = null;
  private video!: HTMLVideoElement;
  private canvas!: HTMLCanvasElement;

  connectedCallback() {
    super.connectedCallback();
    this.root.innerHTML = `
      <style>
        video { width: 100%; max-width: 400px; border-radius: 8px; }
        .controls { margin-top: 10px; display: flex; gap: 10px; }
        button { padding: 6px 10px; cursor: pointer; }
      </style>

      <video autoplay playsinline></video>

      <div class="controls">
        <button id="snap">Take Photo</button>
        <button id="switch">Switch Camera</button>
      </div>

      <canvas style="display:none;"></canvas>
    `;

    this.video = this.root.querySelector<HTMLVideoElement>('video')!;
    this.canvas = this.root.querySelector<HTMLCanvasElement>('canvas')!;

    this.root.querySelector<HTMLElement>('#snap')!.onclick = () => this.capture();
    this.root.querySelector<HTMLElement>('#switch')!.onclick = () => this.switchCamera();

    this.init();
  }

  async init() {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({ video: true });
      this.video.srcObject = this.stream;

      const devices = await navigator.mediaDevices.enumerateDevices();
      this.devices = devices.filter(d => d.kind === 'videoinput');

      this.currentDeviceId = this.devices[0]?.deviceId;
    } catch (err) {
      console.error('Camera init failed:', err);
    }
  }

  async switchCamera() {
    if (this.devices.length < 2) return;

    const index = this.devices.findIndex(d => d.deviceId === this.currentDeviceId);
    const next = (index + 1) % this.devices.length;

    this.currentDeviceId = this.devices[next].deviceId;

    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop());
    }

    this.stream = await navigator.mediaDevices.getUserMedia({
      video: { deviceId: { exact: this.currentDeviceId } }
    });

    this.video.srcObject = this.stream;
  }

  capture() {
    if (!this.video.videoWidth) {
      return;
    }

    const ctx = this.canvas.getContext('2d')!;

    this.canvas.width = this.video.videoWidth;
    this.canvas.height = this.video.videoHeight;

    ctx.drawImage(
      this.video,
      0,
      0
    );

    this.canvas.toBlob(
      (blob) => {

        if (!blob) {
          return;
        }

        this.dispatchEvent(
          new CustomEvent(
            'photo-captured',
            {
              detail: blob,
              bubbles: true
            }
          )
        );

      },
      'image/jpeg',
      0.8
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop());
    }
  }
}

customElements.define('hat-camera-capture', CameraCapture);